module.exports = __webpack_public_path__ + "img/FontAwesome_Contact-Email.2dc55d11.svg";